import { PageHero, CTABand } from "@/components/PageHero";
import { Reveal, ParallaxImg } from "@/components/anim";
import { IMG } from "@/lib/img";

const VALUES = ["Shop.", "Create.", "Connect.", "Grow."];

export default function About() {
  return (
    <>
      <PageHero
        eyebrow="About Essandtials"
        lines={[
          <>A Physical Home</>,
          <>
            For <em>Digital Businesses.</em>
          </>,
        ]}
      />

      <section className="bg-paper pb-24 sm:pb-32" data-testid="about-story">
        <div className="mx-auto grid max-w-[1440px] grid-cols-1 items-center gap-14 px-6 lg:grid-cols-2 lg:gap-20 lg:px-10">
          <div>
            <ParallaxImg
              src={IMG.bermudaArches}
              alt="White Bermudian architecture"
              className="aspect-[3/4] w-full rounded-3xl shadow-[0_30px_80px_rgba(26,24,23,0.12)]"
            />
          </div>
          <div>
            <Reveal>
              <p className="text-lg leading-relaxed text-clay sm:text-xl">
                Essandtials was created to bridge the gap between e-commerce and physical retail
                in Bermuda.
              </p>
            </Reveal>
            <Reveal delay={0.15}>
              <p className="mt-6 text-sm leading-relaxed text-clay sm:text-base">
                Our mission is to provide entrepreneurs with an accessible, beautiful, flexible
                place where they can meet customers, grow their businesses, test retail concepts,
                work with beauty clients, host events, and build stronger brands — all without
                committing to a traditional long-term storefront or salon.
              </p>
            </Reveal>
            <Reveal delay={0.25}>
              <div className="mt-10 grid grid-cols-2 gap-4" data-testid="about-values">
                {VALUES.map((v, i) => (
                  <div
                    key={v}
                    className="rounded-2xl border border-beige/60 bg-white/70 px-6 py-8 text-center"
                  >
                    <p className="font-serif text-2xl italic text-ink sm:text-3xl">{v}</p>
                    <p className="mt-2 text-[10px] uppercase tracking-[0.3em] text-fog">
                      0{i + 1}
                    </p>
                  </div>
                ))}
              </div>
            </Reveal>
          </div>
        </div>
      </section>

      <section className="bg-sand py-24 sm:py-32" data-testid="about-location">
        <div className="mx-auto grid max-w-[1440px] grid-cols-1 items-center gap-14 px-6 lg:grid-cols-2 lg:gap-20 lg:px-10">
          <div className="order-2 lg:order-1">
            <Reveal>
              <p className="font-serif text-4xl uppercase leading-tight text-ink sm:text-5xl">
                Bermuda Brands.
                <br />
                <em>Brighter Together.</em>
              </p>
            </Reveal>
            <Reveal delay={0.15}>
              <p className="mt-6 max-w-xl text-sm leading-relaxed text-clay sm:text-base">
                You&rsquo;ll find us at 39 Dundonald Street in Hamilton — one of Bermuda&rsquo;s
                busiest retail districts, just steps from Front Street. When your customers say
                &ldquo;where are you located?&rdquo;, you&rsquo;ll finally have an answer they can
                walk to.
              </p>
            </Reveal>
          </div>
          <div className="order-1 lg:order-2">
            <ParallaxImg
              src={IMG.store.hooks}
              alt="Inside Essandtials — gold wall hooks and hangers"
              className="aspect-[4/5] w-full rounded-3xl shadow-[0_30px_80px_rgba(26,24,23,0.14)]"
            />
          </div>
        </div>
      </section>

      <CTABand
        title={
          <>
            From online to in-store.
            <br />
            <em>Starts here.</em>
          </>
        }
        cta="Book Your Space"
        to="/book"
        testid="about-cta-button"
      />
    </>
  );
}
